<template>
  <div>
  <v-menu
    bottom
    origin="top center"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        class="font-weight-black"
      >
        <v-icon class="mr-3">mdi-exit-run</v-icon>
        Действия
      </v-btn>
    </template>
    <v-list class="secondary" dark>
      <v-subheader>Действия</v-subheader>
      <v-list-item-group>
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
          @click="callAction(item)"
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
    <sys-change-pass-form v-model="showCPForm" @onSuccess="passChanged" />
  </div>
</template>

<script>
import { AUTH_LOGOUT } from '@/store/actions/auth'
export default {
  name: 'sysApplicationMenu',
  data: () => ({
    items: [
      { title: 'Изменить пароль', icon: 'mdi-account-key', action: 'changePass' },
      { title: 'Выход', icon: 'mdi-exit-to-app', action: 'exit' }
    ],
    showCPForm: false
  }),
  components: {
    SysChangePassForm: () => import(/* webpackChunkName: "sysUI" */ '@/components/common/changePassForm.vue')
  },
  methods: {
    passChanged () {
      this.showCPForm = false
      this.$store.dispatch(AUTH_LOGOUT)
        .then(() => {
          console.log('Logout complete, redirection')
          if (this.$router.currentRoute.path !== '/login') this.$router.push('/login')
        })
    },
    callAction (item) {
      console.log('Calling action', item.action)
      switch (item.action) {
        case 'exit':
          this.$store.dispatch(AUTH_LOGOUT)
            .then((resp) => {
              console.log('Logout complete, redirection')
              if (this.$router.currentRoute.path !== '/login') this.$router.push('/login')
            })
          break
        case 'changePass':
          console.log('Change password')
          this.showCPForm = true
          break
        case 'feedback':
          console.log('Show feedback form')
          this.$emit('onFeedbackEvent')
          break
        default:
          break
      }
    }
  }
}
</script>
